export async function handleFileUpload(
  file: File,
  maxSize: number,
  onError?: (error: string) => void
): Promise<string | null> {
  if (file.size > maxSize) {
    onError?.(`الملف كبير جداً. الحد الأقصى هو ${Math.round(maxSize / (1024 * 1024))}MB`);
    return null;
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => {
      onError?.('حدث خطأ أثناء قراءة الملف');
      resolve(null);
    };
    reader.readAsDataURL(file);
  });
}

export function createPreviewUrl(base64: string | null): string | null {
  if (!base64) return null;
  
  try {
    // Split the base64 string to get content type and data
    const [header, data] = base64.split(',');
    const contentType = header.split(':')[1].split(';')[0];
    
    // Create blob and URL
    const byteCharacters = atob(data);
    const byteArrays = [];
    
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      
      byteArrays.push(new Uint8Array(byteNumbers));
    }
    
    const blob = new Blob(byteArrays, { type: contentType });
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Error creating preview URL:', error);
    return null;
  }
}